import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useSelector } from "react-redux";
import {  selectFeasibilityhasNaCycle, selectHighestCycle } from "../../../slices/feasibility";
import { useEffect, useState } from "react";

const Filter = ({ onApply, onClear, initialFilters }) => {

  const initialValues = {
    clinical_status: "",
    financial_status: "",
    type: "",
    apheresis_date: "",
    product: "",
    cycle: [],
    dashboardFilter: initialFilters?.dashboardFilter ?? false,
    ...initialFilters
  }
 
  const [cycleOptions, setCycleOptions] = useState([]);

  const highestCycle = useSelector(selectHighestCycle);
  const hasNaCycle = useSelector(selectFeasibilityhasNaCycle);
  const clinicialStatusOptions = [
    { value: 1, label: 'Clinical Feasible' },
    { value: 2, label: 'Feasible with Conditions' },
    { value: 3, label: 'Non Feasible' },
  ]

  const financialStatusOptions = [
    { value: 1, label: 'Financial Feasible' },
    { value: 2, label: 'Non Feasible' },
    { value: 3, label: 'Special Approval' },
    { value: 4, label: 'Not Applicable' }
  ]

  const typeOptions = [
    { value: 2, label: 'PMS' },
    { value: 3, label: 'Commercial' },
    { value: 1, label: 'Trial' },
  ]

  // const productOptions = [
  //   { value: 'bcma', label: 'BCMA' },
  //   { value: 'carT', label: 'CAR-T' }
  // ]
const generateCycleOptions = (highestCycle, hasNaCycle) => {
const options = [];
  if (hasNaCycle === 1) {
    options.push({
      value: "N/A",
      label: "N/A",
    });
  }
  const match = highestCycle?.match(/\d+/);
  if (match) {
    const max = parseInt(match[0], 10);
    for (let i = 1; i <= max; i++) {
      options.push({
        value: `Cycle ${i}`,
        label: `Cycle ${i}`,
      });
    }
  }
  return options;
};
useEffect(() => {
  const options = generateCycleOptions(
    highestCycle,
    hasNaCycle
  );
  setCycleOptions(options);
}, [hasNaCycle, highestCycle]);

  const handleCycleChange = (event) => {
    const selectedValues =
      typeof event.target.value === "string"
        ? event.target.value.split(",")
        : event.target.value;

    const filtered = Array.isArray(selectedValues)
      ? selectedValues.filter(Boolean)
      : [];
    formik.setFieldValue("cycle", filtered);
  };
  const formOptions = [
    {
      label: 'Clinical Status',
      type: 'checkbox',
      name: 'clinical_status',
      options: clinicialStatusOptions
    },
    {
      label: 'Financial Status',
      type: 'checkbox',
      name: 'financial_status',
      options: financialStatusOptions
    },
    {
      label: 'Type',
      type: 'checkbox',
      name: 'type',
      options: typeOptions
    },
    {
      label: 'Apheresis Date',
      type: 'date',
      name: 'apheresis_date',
      placeholder: 'Select Date',
      position: 'top'
    },
    {
      label: 'Cycle',
      type: 'select',
      multiple: true,
      name: 'cycle',
      placeholder: 'Select Cycle',
      options: cycleOptions,
      onChange: handleCycleChange,
    },
    {
      label: 'Dashboard Filter',
      type: 'switch',
      name: 'dashboardFilter',
      hideLabel: true
    }
    // {
    //   label: 'Product',
    //   type: 'select',
    //   name: 'product',
    //   placeholder: 'Select Product',
    //   options: productOptions
    // }
  ]

  const handleSubmit = (values) => {
    onApply({
      ...values,
    });
  };
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit
  })

  const handleClear = () => {
    formik.setValues({
      clinical_status: "",
      financial_status: "",
      type: "",
      apheresis_date: "",
      product: "",
      cycle: [],
      dashboardFilter: false
    });
    onClear();
  };

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        {formOptions.map((props, key) => {
          const isDashboard = props.name === 'dashboardFilter';
          return (
            <Grid
              key={key}
              item
              xs={12}
              sx={isDashboard ? {
                background: '#F0F5FF',
                borderRadius: '8px',
                padding: '10px 12px',
                border: '1px solid #D6E4FF',
                marginBottom: '12px',
                marginTop: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                '& .MuiFormControlLabel-root': {
                  margin: 0,
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'row-reverse'
                }
              } : {}}
            >
              <FormikControl formik={formik} {...props} />
            </Grid>
          );
        })}

        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, marginTop: "10px" }}>
          <LoadingButton size="large" sx={{ borderRadius: "6px" }} onClick={handleClear} variant="outlined">Clear Filter</LoadingButton>
          <LoadingButton size="large" sx={{ borderRadius: "6px" }} type="submit" variant="contained">Apply Filter</LoadingButton>
        </Box>
      </form>
    </Box>
  );
}

export default Filter;
